<template>
    <div class="page-index">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style src="./style.less" lang="less"></style>